/**
 * Section: Ambassadors Listing
 * Liquid can only iterate 50 pages per paginate batch, so ambassadors may be
 * spread over several batches. This element fetches each remaining batch from
 * the Section Rendering API and appends its cards to the grid.
 */
if (!customElements.get('ambassador-grid')) {
  class AmbassadorGrid extends HTMLElement {
    connectedCallback() {
      this.#loadRemainingBatches();
    }

    async #loadRemainingBatches() {
      let nextUrl = this.dataset.nextUrl;

      while (nextUrl) {
        const url = new URL(nextUrl, window.location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);

        try {
          const response = await fetch(url);

          if (!response.ok) {
            return;
          }

          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const batchGrid = doc.getElementById(this.id);

          if (!batchGrid) {
            return;
          }

          this.append(...batchGrid.children);
          nextUrl = batchGrid.dataset.nextUrl;
        } catch (error) {
          console.error('Failed to load more ambassadors', error);
          return;
        }
      }
    }
  }

  customElements.define('ambassador-grid', AmbassadorGrid);
}
